import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "banner"

export type bannerList = {
    keyword?: string;
    start_date?: string;
    end_date?: string;
    limit?: number;
    page?: number;
    sortBy?: string;
    sortType?: string;
    banner_group: string;
}

export type createdBanner = {
    is_public: boolean;
    seq: number | null;
    banner_start_date: string;
    banner_end_date: string;
    banner_name: string;
    banner_desc: string;
    banner_link: string;
    banner_status_open: string;
    id_media_file: number | null;
    banner_start_time?: string;
    banner_end_time?: string;
    banner_group: string;
}

export type updateStatusBannerType = {
    status: string;
}

export class BannerApi extends BaseAPI {
    static getList(query: bannerList): Promise<AxiosResponse> {
        return this.api.get(`${path}`, { params: { ...query } })
    }
    static delete(id_banner: number): Promise<AxiosResponse> {
        return this.api.delete(`${path}/${id_banner}`)
    }
    static update(id_banner: number, body: createdBanner): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_banner}`, body)
    }
    static createBanner(body: createdBanner): Promise<AxiosResponse> {
        return this.api.post(`${path}`, body)
    }
    static findOne(id_banner: number): Promise<AxiosResponse> {
        return this.api.get(`${path}/${id_banner}`)
    }
    static updateStatus(id_banner: number, body: updateStatusBannerType): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_banner}/status`, body)
    }
}